module.exports = __webpack_public_path__ + "img/zixinche.6509c751.png";